module.exports = __webpack_public_path__ + "img/dcg-03.prt.294fa644.jpg";